import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AgentsBetaGate } from "~/components/workspace/AgentsBetaGate";

// `/agents` is a layout: the list renders at `/agents/` (agents.index.tsx) and a
// single agent's window at `/agents/$agentId` (agents.$agentId.tsx). The `?agent=`
// search param stays declared here (validated for the whole subtree) so the sidebar's
// `navigate({ to: "/agents", search: { agent } })` deep-link keeps working — the index
// reads it and opens that agent's window.
export type AgentsSearch = {
  readonly agent?: string;
  readonly mock?: string;
};

export const Route = createFileRoute("/agents")({
  validateSearch: (raw: Record<string, unknown>): AgentsSearch => ({
    ...(typeof raw.agent === "string" && raw.agent ? { agent: raw.agent.slice(0, 50) } : {}),
    ...(typeof raw.mock === "string" ? { mock: raw.mock.slice(0, 1) } : {}),
  }),
  component: () => (
    <AgentsBetaGate>
      <Outlet />
    </AgentsBetaGate>
  ),
});
